export default __webpack_public_path__ + "locales/fi/RoomLogoCover.json?hash=1b927bb6a5f0d15edac44d62e6ad8882";